import React, { useState } from 'react';
import Notification from './Notification';
import SearchBar from './SearchBar';
import Users from './User';
import { UL } from '../../../AbstractElements';
import SoS from '../../../Components/sos/SoS';
import { LI } from '../../../AbstractElements';

const RightHeader = () => {
  const [active, setActive] = useState();

  return (
    <div className="simple-list nav-right col-6 pull-right right-header p-0">
      <UL attrUL={{ className: "nav-menus d-flex align-items-center" }} >
        <SearchBar />
        
        {/* SoS with title attribute tooltip */}
        <LI attrLI={{ className: "onhover-dropdown", title: "SoS Emergency" }}>
           <SoS />
        </LI>
        
        {/* Notification with title attribute tooltip */}
        <LI attrLI={{ title: "Notifications" }}>
          <Notification active={active} setActive={setActive} />
        </LI>
        
        <Users />
      </UL>
    </div>
  );
};

export default RightHeader;